import moment from "moment";

export const formatToStandardDateUTC = (date: string, utcPrefix = ' (UTC)', emptySymbol = '-') => {
  return date ? `${moment.utc(new Date(date)).format("MMM D, YYYY")}${utcPrefix}` : emptySymbol;
};
